import React, {useEffect, useState} from "react";
import {CopyToClipboard} from "../CopyToClipboard/CopyToClipboard";
import "./style.scss";
import environment from "environment";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";
import SectionItemText from "../SectionItemText";
import {downloadImage} from "../../../utils/image-util";
import {DebounceInput} from "react-debounce-input";
import {getLinkStats} from "../../../api/restaurant-requests";
import {useTranslation} from "react-i18next";
import ChartControl from "../ChartControl";
import {CHART_MODEL} from "../../../utils/enums";
import {createChartModel} from "../../../services/chartModelFactory";
import {getDeepLinkStatsChartModelData} from "../../../services/chart";
import {objectKeysToUpperLowerCase} from "../../../utils/objects-util";

const CopySection = ({column, item, onPropChange, value}) => {
    const {t} = useTranslation();

    return (
        <div className={"copySection"}>
            <SectionItemText value={value} column={{...column, isReadonly: true, title: t("settings.deepLink.LINK")}} item={item} onPropChange={onPropChange} />
            <CopyToClipboard text={t("settings.deepLink.COPY")} dataForClipboard={value}/>
        </div>
    );
}

const QrcodeSection = ({column, item, onPropChange, value}) => {
    const {t} = useTranslation();

    const [qrState, setQrState] = useState("");

    useEffect(() => {
        if(value) {
            const size = 200;
            setQrState(`${environment.qrserverAPI}?size=${size}x${size}&data=${value}`);
        }

    }, [value]);

    const handleOnDownload = () => {
        downloadImage(qrState.replace('http://', 'https://'));
    }

    return (
        <div className={"qrSection"}>
            <ColumnTitleWithIcon column={{...column, title: t("settings.deepLink.QR_CODE")}} item={item} onPropChange={onPropChange} />
            <img
                alt={"qr-code"}
                src={qrState}
            />
            <div className={"download"} onClick={handleOnDownload}>{t("settings.deepLink.DOWNLOAD")}</div>
        </div>
    )
}

const ChartSection = ({column, item, onPropChange, value}) => {
    const {t} = useTranslation();

    const [data, setData] = useState({});
    const [period, setPeriod] = useState(7);

    const handleOnChangePeriod = e => {
        setPeriod(e.target.value);
    }

    useEffect(() => {
        if(period && value) {
            getLinkStats(value, period).then(statistics => {
                const statInLoverCase = objectKeysToUpperLowerCase(statistics.data);

                const chartData = createChartModel(CHART_MODEL.deepLinkStats,
                    getDeepLinkStatsChartModelData(statInLoverCase.linkEventStats || [])
                );
                setData(chartData);
            });
        }
    }, [period, value]);

    return (
        <div className={"chartSection"}>
            <div className={"period"}>
                <ColumnTitleWithIcon column={{...column, title: t("settings.deepLink.PERIOD")}} item={item} onPropChange={onPropChange} />
                <div className={"periodTime"}>
                    <DebounceInput type={"number"} className={"periodInput"} debounceTimeout={400} value={period} onChange={handleOnChangePeriod}/>
                    <div className={"periodShortcut"} onClick={() => setPeriod(1)}>{t("settings.deepLink.filter.DAY")}</div>
                    <div className={"periodShortcut"} onClick={() => setPeriod(7)}>{t("settings.deepLink.filter.WEEK")}</div>
                    <div className={"periodShortcut"} onClick={() => setPeriod(30)}>{t("settings.deepLink.filter.MONTH")}</div>
                    <div className={"periodShortcut"} onClick={() => setPeriod(365)}>{t("settings.deepLink.filter.YEAR")}</div>
                </div>

                <ColumnTitleWithIcon column={{...column, title: t("settings.deepLink.TABLE")}} item={item} onPropChange={onPropChange} />
                <ChartControl value={data}/>
            </div>
        </div>
    )    
}

const SectionItemDeepLinkStats = ({column, item, onPropChange, value}) => {
    return <div className={"sectionItemDeepLinkStat"}>
        <QrcodeSection column={column} item={item} value={value} onPropChange={onPropChange} />
        {!column.hideChart && (
          <ChartSection column={column} item={item} value={value} onPropChange={onPropChange} />
        )}
        <CopySection column={column} item={item} value={value} onPropChange={onPropChange} />
    </div>
}

export default SectionItemDeepLinkStats;
